import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment.prod'
import { Firestore, collection, collectionData, query, orderBy } from '@angular/fire/firestore';


@Injectable({
  providedIn: 'root'
})

export class TablesService {

  constructor(private http: HttpClient) { }
  
  private firestore = inject(Firestore);

  get(userId: string, appId: string): Observable<any[]> {
    const tablesRef = collection(this.firestore, `Users/${userId}/Apps/${appId}/Tables`);
    const tablesQuery = query(tablesRef, orderBy('created_at', 'desc'));
    return collectionData(tablesQuery, { idField: 'id' });
  }


  showOne(id: number){
    return this.http.get(environment.apiUrl + 'app/' + id)
  }

  create(data: any){
    return this.http.post(environment.apiUrl + "auth/create/table/", data);
  }

  delete(data: any){
    return this.http.post(environment.apiUrl + "auth/delete/table/", data);
  }
}
